<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
        (click)="closeModal()">×</button>
    <h4 class="modal-title wrap-text-in">Resolve Conflicts</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <div class="col-xs-12">
                <app-compare-and-update-candidate-details
                    [candidateConflictDetails]="candidateConflictDetails"
                    (saveCallback)="saveCallback($event.contactDetails)"
                    (cancelCallback)="closeModal()">
                </app-compare-and-update-candidate-details>
            </div>
        </div>
    </div>
</div>
